import { createAction } from 'redux-actions';
import Types from './types';

export const getAllUserCompanyRequest = createAction(
  Types.GET_ALL_USER_COMPANY_REQUEST
);
export const getAllUserCompanyFulfilled = createAction(
  Types.GET_ALL_USER_COMPANY_FULFILLED
);
export const getAllUserCompanyRejected = createAction(
  Types.GET_ALL_USER_COMPANY_REJECTED
);

export const getCompanyRequest = createAction(Types.GET_COMPANY_REQUEST);
export const getCompanyFulfilled = createAction(Types.GET_COMPANY_FULFILLED);
export const getCompanyRejected = createAction(Types.GET_COMPANY_REJECTED);

export const getAllCompaniesRequest = createAction(
  Types.GET_ALL_COMPANIES_REQUEST
);
export const getAllCompaniesFulfilled = createAction(
  Types.GET_ALL_COMPANIES_FULFILLED
);
export const getAllCompaniesRejected = createAction(
  Types.GET_ALL_COMPANIES_REJECTED
);

export const getAllCompaniesOperatorRequest = createAction(
  Types.GET_ALL_COMPANIES_OPERATOR_REQUEST
);
export const getAllCompaniesOperatorFulfilled = createAction(
  Types.GET_ALL_COMPANIES_OPERATOR_FULFILLED
);
export const getAllCompaniesOperatorRejected = createAction(
  Types.GET_ALL_COMPANIES_OPERATOR_REJECTED
);

export const editCompanyNamesRequest = createAction(
  Types.EDIT_COMPANY_NAMES_REQUEST
);
export const editCompanyNamesFulfilled = createAction(
  Types.EDIT_COMPANY_NAMES_FULFILLED
);
export const editCompanyNamesRejected = createAction(
  Types.EDIT_COMPANY_NAMES_REJECTED
);
